import { RangeFacetCountsDTO, MappedRangeFacetItem } from "./filters.type";

export const mapRangeFacetCounts = (
  results: RangeFacetCountsDTO
): MappedRangeFacetItem[] => {
  const counts = results.availableOptions.map((item) => ({
    from: item.from,
    to: item.to,
    count: item.count,
    fromUnit: item.fromUnit,
    toUnit: item.toUnit,
  }));

  return counts;
};
